import React from "react";
import styled from "styled-components";
import { useNewYear2025Theme } from "../../../../../helper/const";

export default function ComponentLink({ dataLink }) {
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  return (
    <Container
      className={`${
        IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
      } container-link`}
    >
      <div className='btn-prize'>
        <div className='chilren-button' />
        <div className='content-link'>
          {dataLink.map((item) => {
            return (
              <div key={item.id} onClick={item.action} className='link-detail'>
                <img
                  src={item.srcImg}
                  alt=''
                  className='link-img'
                  height={item.height}
                />
                <p className='link-content'>{item.content}</p>
              </div>
            );
          })}
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 20px;

  .link-detail {
    position: relative;
    margin: 0 auto;
    top: -18px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 430px) {
      top: -30px;
    }
  }

  .btn-prize {
    background: linear-gradient(to bottom, #de6317 0%, #f8bf86 100%) !important;
    height: 92px;
    border: 2px solid #f8bd84 !important;
    width: 416px;
    padding: 0 10px;
    border-radius: 400px;
    position: relative;
    color: white !important;
    z-index: 2;
  }

  .chilren-button {
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.34) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 40px;
    width: calc(100% - 16px);
    height: calc(100% - 16px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .content-link {
    display: grid;
    grid-template-columns: 50% 45%;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    font-weight: bold;
    position: relative;
    z-index: 23;

    @media (max-width: 576px) {
      font-size: 16px;
    }
  }

  @media (min-width: 992px) {
    .link-detail:hover {
      scale: 1.02;
      transition: 0.3s ease-in-out;
    }
  }

  @media (max-width: 430px) {
    .btn-prize {
      width: 90% !important;
      height: 80px !important;
    }
  }

  .link-content {
    font-weight: 700;
    color: #64310b;
    position: absolute;
    width: max-content;
    bottom: -10px;
    text-shadow: -1px -1px 0 #fdcaa4, 1px -1px 0 #fdcaa4, -1px 1px 0 #fdcaa4,
      1px 1px 0 #fdcaa4;
  }

  &.new-year-25-theme {
    .btn-prize {
      background: radial-gradient(
        circle at 50% -85%,
        #b20202 50%,
        #180000 100%
      ) !important;
      border: 3px solid #b33e3e !important;
    }
    .chilren-button {
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      filter: blur(2px);
    }
    .link-content {
      color: #fff;
      text-shadow: -1px -1px 0 #800e0e, 1px -1px 0 #800e0e, -1px 1px 0 #800e0e,
        1px 1px 0 #800e0e;
    }
  }
`;
